/** 价格监管电子围栏区域（上饶·婺源），手动实景多边形，景区+外围3km范围 */
export const PRICE_FENCE_REGIONS = [
  {
    id: 'wuyuan_all',
    name: '婺源全城',
    matchAreas: ['紫阳镇城区'],
    paths: [
      { lat: 29.290823543, lng: 117.87159212190 },
      { lat: 29.2565075293, lng: 117.89578393269 },
      { lat: 29.2052092747, lng: 117.8942012921 },
      { lat: 29.2205998173, lng: 117.8256452206 },
      { lat: 29.24540835132, lng: 117.7935771190094 },
      { lat: 29.290788799862806, lng: 117.82790805825846 },
      
    ],
    mapCenter: { lat: 29.248664327784503, lng: 117.86470161461887 },
    mapZoom: 11.2,
    priceConfig: {
      week7: {
        peak: 320,
        trough: 180,
        dailyPrices: [320, 320, 320, 290, 265, 235, 205]
      },
      week14: {
        minPrice: 130,
        peak: 320,
        dailyPrices: [130, 149, 168, 187, 206, 225, 244, 263, 282, 301, 314, 318, 319, 320]
      }
    }
  },
  {
    id: 'huangling',
    name: '篁岭景区周边',
    matchAreas: ['篁岭景区'],
    paths: [
      { lat: 29.339120, lng: 118.121447 },
      { lat: 29.323084, lng: 118.106452 },
      { lat: 29.307745, lng: 118.108309 },
      { lat: 29.301844, lng: 118.121504 },
      { lat: 29.311433, lng: 118.134191 },
      { lat: 29.324560, lng: 118.134530 },
      { lat: 29.339077, lng: 118.122206 }
    ],
    mapCenter: { lat: 29.317898, lng: 118.120739 },
    mapZoom: 13.6,
    priceConfig: {
      week7: {
        peak: 1160,
        trough: 610,
        dailyPrices: [1160, 1160, 1160, 1040, 900, 740, 610],
        lastYearWeek7: [1230, 1190, 1160, 1000, 840, 670, 520]
      },
      week14: {
        minPrice: 290,
        peak: 1160,
        dailyPrices: [290, 344, 398, 452, 506, 560, 614, 1160, 1160, 1040, 900, 740, 670, 610],
        lastYearWeek14: [320, 370, 420, 470, 520, 570, 620, 1230, 1190, 1160, 1000, 840, 670, 520]
      }
    }
  },
  {
    id: 'wunvzhou',
    name: '婺女洲度假区周边',
    matchAreas: ['婺女洲度假区'],
    paths: [
      { lat: 29.296312, lng: 117.86421 },
      { lat: 29.28519933, lng: 117.87157453 },
      { lat: 29.27645954, lng: 117.868331072 },
      { lat: 29.27206409, lng: 117.8609174 },
      { lat: 29.27448919, lng: 117.848291080 },
      { lat: 29.2903014, lng: 117.85107119 },
      { lat: 29.2958578463, lng: 117.857558128 }
    ],
    mapCenter: { lat: 29.28428661918369, lng: 117.85899104914218 },
    mapZoom: 13.8,
    priceConfig: {
      week7: {
        peak: 870,
        trough: 390,
        dailyPrices: [870, 870, 870, 855, 720, 590, 450]
      },
      week14: {
        minPrice: 255,
        peak: 870,
        dailyPrices: [255, 300, 345, 390, 435, 480, 525, 870, 870, 855, 720, 590, 520, 450]
      }
    }
  },
  {
    id: 'likeng',
    name: '李坑古村周边',
    matchAreas: ['李坑古村'],
    paths: [
      { lat: 29.342570427832364, lng: 117.93211957717923 },
      { lat: 29.334845677717184, lng: 117.91664748996489 },
      { lat: 29.32196979852898, lng: 117.91538159014438 },
      { lat: 29.315966616713315, lng: 117.92519732296713 },
      { lat: 29.315610206795505, lng: 117.94177925992922 },
      { lat: 29.328378272967023, lng: 117.94642390710245 },
      { lat: 29.335772428198372, lng: 117.95023988746467 },
      { lat: 29.338502209876837, lng: 117.94082029676095 }
    ],
    mapCenter: { lat: 29.3247360804523, lng: 117.92970582741596 },
    mapZoom: 13.4,
    priceConfig: {
      week7: {
        peak: 750,
        trough: 380,
        dailyPrices: [750, 750, 750, 680, 610, 490, 420]
      },
      week14: {
        minPrice: 250,
        peak: 750,
        dailyPrices: [250, 288, 326, 364, 402, 440, 478, 750, 750, 680, 610, 490, 420, 370]
      }
    }
  },
  {
    id: 'jiangling',
    name: '江岭油菜花片区周边',
    matchAreas: ['江岭景区'],
    paths: [
      { lat: 29.47230042004786, lng: 118.022834442006 },
      { lat: 29.46391204436284, lng: 118.0143144044 },
      { lat: 29.420563920912557, lng: 118.04163542885609 },
      { lat: 29.430150667116987, lng: 118.0594952125 },
      { lat: 29.480638936242923, lng: 118.03705215529483 }
    ],
    mapCenter: { lat: 29.453291185350914, lng: 118.033826430 },
    mapZoom: 12.6,
    priceConfig: {
      week7: {
        peak: 640,
        trough: 330,
        dailyPrices: [640, 640, 640, 580, 520, 420, 350]
      },
      week14: {
        minPrice: 210,
        peak: 640,
        dailyPrices: [210, 242, 274, 306, 338, 370, 402, 640, 640, 580, 520, 420, 350, 320]
      }
    }
  },
]

export function generatePriceTrendByRegion(regionId, dayCount) {
  const region = getPriceFenceRegionById(regionId)
  
  if (!region || !region.priceConfig) {
    return generateDefaultTrend(dayCount)
  }
  
  const config = region.priceConfig
  const isWeek7 = dayCount === 7
  const baseDate = new Date(2026, 4, 7)
  
  // 生成日期数组
  const dates = []
  for (let i = dayCount - 1; i >= 0; i--) {
    const d = new Date(baseDate)
    d.setDate(baseDate.getDate() - i)
    dates.push(`${d.getMonth() + 1}-${d.getDate()}`)
  }
  
  // 获取近期价格
  let recentSeries = []
  let lastMonthSeries = []
  
  if (isWeek7 && config.week7) {
    recentSeries = [...config.week7.dailyPrices]
    // 使用配置的上年同期价格
    if (config.week7.lastYearWeek7) {
      lastMonthSeries = [...config.week7.lastYearWeek7]
    } else {
      lastMonthSeries = generateLastMonthPrices(recentSeries, region.name)
    }
  } else if (!isWeek7 && config.week14) {
    recentSeries = [...config.week14.dailyPrices]
    // 使用配置的上年同期价格
    if (config.week14.lastYearWeek14) {
      lastMonthSeries = [...config.week14.lastYearWeek14]
    } else {
      lastMonthSeries = generateLastMonthPrices(recentSeries, region.name)
    }
  } else {
    const peak = config.week7.peak || 500
    const trough = config.week7.trough || 300
    recentSeries = generateDefaultPrices(dayCount, peak, trough)
    lastMonthSeries = generateLastMonthPrices(recentSeries, region.name)
  }
  
  return { dates, recentSeries, lastMonthSeries }
}
/**
 * 根据商户生成价格趋势数据
 * @param {Object} hotel - 酒店对象
 * @param {number} dayCount - 天数（7或14）
 * @returns {Object} { dates, recentSeries, lastMonthSeries }
 */
export function generatePriceTrendByHotel(hotel, dayCount) {
  if (!hotel || !hotel.priceTrend) {
    // 如果没有商户特定数据，使用区域默认数据
    const regionId = hotel.fenceRegionId || 'wuyuan_all'
    return generatePriceTrendByRegion(regionId, dayCount)
  }
  
  const isWeek7 = dayCount === 7
  const baseDate = new Date(2026, 4, 7)
  
  // 生成日期数组
  const dates = []
  for (let i = dayCount - 1; i >= 0; i--) {
    const d = new Date(baseDate)
    d.setDate(baseDate.getDate() - i)
    dates.push(`${d.getMonth() + 1}-${d.getDate()}`)
  }
  
  // 获取商户价格数据
  let recentSeries = []
  let lastMonthSeries = []
  
  if (isWeek7 && hotel.priceTrend.week7) {
    recentSeries = [...hotel.priceTrend.week7]
    // 使用商户配置的上年同期价格
    if (hotel.priceTrend.lastYearWeek7) {
      lastMonthSeries = [...hotel.priceTrend.lastYearWeek7]
    } else {
      lastMonthSeries = generateLastMonthPrices(recentSeries, hotel.hotelName)
    }
  } else if (!isWeek7 && hotel.priceTrend.week14) {
    recentSeries = [...hotel.priceTrend.week14]
    // 使用商户配置的上年同期价格
    if (hotel.priceTrend.lastYearWeek14) {
      lastMonthSeries = [...hotel.priceTrend.lastYearWeek14]
    } else {
      lastMonthSeries = generateLastMonthPrices(recentSeries, hotel.hotelName)
    }
  } else {
    // 降级方案
    const peak = hotel.realTimePrice || 500
    const trough = hotel.historyAvgPrice || 300
    recentSeries = generateDefaultPrices(dayCount, peak, trough)
    lastMonthSeries = generateLastMonthPrices(recentSeries, hotel.hotelName)
  }
  
  return { dates, recentSeries, lastMonthSeries }
}

function generateLastMonthPrices(currentPrices, name) {
  let seed = 0
  for (let i = 0; i < name.length; i++) {
    seed += name.charCodeAt(i)
  }
  
  return currentPrices.map((price, index) => {
    const randomValue = ((seed * (index + 1) * 16807) % 2147483647) / 2147483647
    let ratio
    
    // 让部分日期上年价格高于今年，部分低于今年
    if (index % 3 === 0) {
      // 上年价格比今年高 5%-20%
      ratio = 1.05 + randomValue * 0.15
    } else if (index % 3 === 1) {
      // 上年价格比今年低 5%-25%
      ratio = 0.75 + randomValue * 0.2
    } else {
      // 上年价格与今年持平或略低
      ratio = 0.9 + randomValue * 0.15
    }
    
    let lastYearPrice = Math.round(price * ratio)
    lastYearPrice = Math.max(lastYearPrice, Math.round(price * 0.5))
    
    return lastYearPrice
  })
}
/**
 * 生成默认趋势数据
 */
function generateDefaultTrend(dayCount) {
  const dates = []
  const baseDate = new Date(2026, 4, 7)
  for (let i = dayCount - 1; i >= 0; i--) {
    const d = new Date(baseDate)
    d.setDate(baseDate.getDate() - i)
    dates.push(`${d.getMonth() + 1}-${d.getDate()}`)
  }
  
  const recentSeries = generateDefaultPrices(dayCount, 500, 300)
  const lastMonthSeries = recentSeries.map(price => Math.round(price * 0.65))
  
  return { dates, recentSeries, lastMonthSeries }
}

/**
 * 生成默认价格序列
 */
function generateDefaultPrices(dayCount, peak, trough) {
  const prices = []
  const step = (peak - trough) / (dayCount - 1)
  for (let i = 0; i < dayCount; i++) {
    const price = peak - step * i
    prices.push(Math.round(price))
  }
  return prices
}

export function getPriceFenceRegionById(regionId) {
  return PRICE_FENCE_REGIONS.find(item => item.id === regionId) || PRICE_FENCE_REGIONS[0]
}

export function filterHotelsByFenceRegion(hotels, regionId) {
  const region = getPriceFenceRegionById(regionId)
  if (!region || !region.matchAreas) return hotels.slice()
  return hotels.filter(hotel => region.matchAreas.includes(hotel.area))
}

export const accommodationPriceList = [
  // 婺女洲湖景民宿
  {
    hotelId: "wy-wunvzhou-mengli",
    hotelName: "婺女洲梦里水乡民宿",
    area: "婺女洲度假区",
    fenceRegionId: "wunvzhou",
    roomType: "亲水双床",
    realTimePrice: 870,
    historyAvgPrice: 390,
    premiumRate: 123.08,
    dealStatus: 'doing',
    complaintCount30Days: 2,
    complaints: [
      { type: '卫生清洁', content: '【黑猫】床品污渍、浴室有保洁遗留泡沫导致滑倒' },
      { type: '设施设备', content: '【微博】热水器失灵，一直都是冷水' },
      { type: '设施设备', content: '【微博】隔音很差，能听到走道游客的声音' }
    ],
    warnings: [{
      id: "wy-wunvzhou-mengli-1",
      message: "溢价超120%，度假区高风险监测民宿",
    }],
    priceTrend: {
      week7: [870, 870, 870, 855, 720, 590, 450],
      week14: [255, 300, 345, 390, 435, 480, 525, 870, 870, 855, 720, 590, 520, 450]
    }
  },
  {
    hotelId: "wy-wunvzhou-yuanju",
    hotelName: "婺女洲园居别院民宿",
    area: "婺女洲度假区",
    fenceRegionId: "wunvzhou",
    roomType: "园林大床",
    realTimePrice: 800,
    historyAvgPrice: 375,
    premiumRate: 113.33,
    dealStatus: 'doing',
    complaintCount30Days: 1,
    complaints: [
      { type: '服务接待', content: '【黑猫】入住高峰期办理缓慢' }
    ],
    warnings: [{
      id: "wy-wunvzhou-yuanju-1",
      message: "假期价格近乎翻倍，纳入重点监管",
    }],
    priceTrend: {
      week7: [800, 800, 800, 785, 670, 550, 420],
      week14: [235, 275, 315, 355, 395, 435, 475, 800, 800, 785, 670, 550, 420, 380]
    }
  },
  {
    hotelId: "wy-wunvzhou-jiangyue",
    hotelName: "婺女洲江月小栈民宿",
    area: "婺女洲度假区",
    fenceRegionId: "wunvzhou",
    roomType: "江景大床",
    realTimePrice: 670,
    historyAvgPrice: 345,
    premiumRate: 94.20,
    complaintCount30Days: 1,
    dealStatus: 'doing',
    complaints: [
      { type: '客房配套', content: '【携程】洗漱备品供应不足' }
    ],
    warnings: [],
    priceTrend: {
      week7: [670, 670, 670, 630, 540, 430, 360],
      week14: [200, 235, 270, 305, 340, 375, 410, 670, 670, 630, 540, 430, 360, 330]
    }
  },
  {
    hotelId: "wy-wunvzhou-cuilou",
    hotelName: "婺女洲翠楼loft民宿",
    area: "婺女洲度假区",
    fenceRegionId: "wunvzhou",
    roomType: "星空loft",
    realTimePrice: 600,
    historyAvgPrice: 320,
    premiumRate: 87.50,
    complaintCount30Days: 2,
    dealStatus: 'doing',
    complaints: [
      { type: '房屋设施', content: '【美团】loft楼梯陡峭老人不便' },
      { type: '环境噪音', content: '【黑猫】夜间街区演艺噪音' }
    ],
    warnings: [{
      id: "wy-wunvzhou-cuilou-1",
      message: "淡旺季价差悬殊，规范定价公示",
    }],
    priceTrend: {
      week7: [600, 600, 600, 555, 480, 380, 320],
      week14: [180, 215, 250, 285, 320, 355, 390, 600, 600, 555, 480, 380, 320, 290]
    }
  },
  // 篁岭本土徽村民宿
  {
    hotelId: "wy-huangling-mingyuan",
    hotelName: "篁岭明园山居民宿",
    area: "篁岭景区",
    fenceRegionId: "huangling",
    roomType: "观景大床房",
    realTimePrice: 1160,
    historyAvgPrice: 610,
    premiumRate: 90.16,
    complaintCount30Days: 0,
    dealStatus: 'doing',
    complaints: [],
    warnings: [{
      id: "wy-huangling-mingyuan-1",
      message: "五一晒秋观景房溢价偏高，片区价格标杆",
    }],
    priceTrend: {
      week7: [1160, 1160, 1160, 1040, 900, 740, 610],
      lastYearWeek7: [1230, 1190, 1160, 1000, 840, 670, 520],
      week14: [290, 344, 398, 452, 506, 560, 614, 1160, 1160, 1040, 900, 740, 670, 610],
      lastYearWeek14: [320, 370, 420, 470, 520, 570, 620, 1230, 1190, 1160, 1000, 840, 670, 520]
    }
  },
  {
    hotelId: "wy-huangling-wanxi",
    hotelName: "篁岭晚溪徽舍民宿",
    area: "篁岭景区",
    fenceRegionId: "huangling",
    roomType: "山景双床",
    realTimePrice: 1070,
    historyAvgPrice: 580,
    premiumRate: 84.48,
    complaintCount30Days: 0,
    dealStatus: 'doing',
    complaints: [],
    warnings: [{
      id: "wy-huangling-wanxi-1",
      message: "节前三日连续涨价，涨幅超四成",
    }],
    priceTrend: {
      week7: [1070, 1070, 1070, 960, 830, 670, 560],
      lastYearWeek7: [1140, 1110, 1070, 920, 770, 600, 480],
      week14: [280, 326, 372, 418, 464, 510, 556, 1070, 1070, 960, 830, 670, 560, 500],
      lastYearWeek14: [310, 360, 410, 460, 510, 560, 610, 1140, 1110, 1070, 920, 770, 600, 480]
    }
  },
  {
    hotelId: "wy-huangling-qiaotou",
    hotelName: "篁岭桥头人家民宿",
    area: "篁岭景区",
    fenceRegionId: "huangling",
    roomType: "露台景观房",
    realTimePrice: 1000,
    historyAvgPrice: 550,
    premiumRate: 81.82,
    dealStatus: 'doing',
    complaintCount30Days: 0,
    complaints: [],
    warnings: [{
      id: "wy-huangling-qiaotou-1",
      message: "多平台标价不一致，存在价差风险",
    }],
    priceTrend: {
      week7: [1000, 1000, 1000, 890, 770, 620, 510],
      week14: [260, 304, 348, 392, 436, 480, 524, 1000, 1000, 890, 770, 620, 510, 450]
    }
  },
  {
    hotelId: "wy-huangling-gujie",
    hotelName: "篁岭古街小筑民宿",
    area: "篁岭景区",
    fenceRegionId: "huangling",
    roomType: "街巷双床房",
    realTimePrice: 890,
    dealStatus: 'doing',
    historyAvgPrice: 520,
    premiumRate: 71.15,
    complaintCount30Days: 0,
    complaints: [],
    warnings: [],
    priceTrend: {
      week7: [890, 890, 890, 800, 700, 560, 450],
      week14: [230, 270, 310, 350, 390, 430, 470, 890, 890, 800, 700, 560, 450, 400]
    }
  },

  // 紫阳镇城区民宿
  {
    hotelId: "wy-county-chengxin",
    hotelName: "婺源城心简居民宿",
    area: "紫阳镇城区",
    fenceRegionId: "wuyuan_all",
    roomType: "高级大床",
    realTimePrice: 320,
    historyAvgPrice: 180,
    premiumRate: 77.78,
    complaintCount30Days: 2,
    dealStatus: 'doing',
    complaints: [
      { type: '宣传不符', content: '【黑猫】房间面积与宣传不符 2026.05.24' },
      { type: '服务人力', content: '【微博】五一接待人手不足效率低 2026.05.05' }
    ],
    warnings: [{
      id: "wy-county-chengxin-1",
      message: "单日售价浮动频繁，日常持续监测",
    }],
    priceTrend: {
      week7: [320, 320, 320, 290, 265, 235, 205],
      week14: [130, 149, 168, 187, 206, 225, 244, 263, 282, 301, 314, 318, 319, 320]
    }
  },

  // 李坑古村民宿
  {
    hotelId: "wy-likeng-shanfang",
    hotelName: "李坑山房徽韵民宿",
    area: "李坑古村",
    fenceRegionId: "likeng",
    roomType: "蜜月大床房",
    realTimePrice: 750,
    historyAvgPrice: 380,
    premiumRate: 97.37,
    complaintCount30Days: 1,
    dealStatus: 'doing',
    complaints: [
      { type: '配套交通', content: '【美团】古村内停车需步行进村' }
    ],
    warnings: [{
      id: "wy-likeng-shanfang-1",
      message: "同片区民宿标价参差不齐，统一指导价提醒",
    }],
    priceTrend: {
      week7: [750, 750, 750, 680, 610, 490, 420],
      week14: [250, 288, 326, 364, 402, 440, 478, 750, 750, 680, 610, 490, 420, 370]
    }
  },

  // 江岭梯田民宿
  {
    hotelId: "wy-jiangling-tianyuan",
    hotelName: "江岭田园观景民宿",
    area: "江岭景区",
    fenceRegionId: "jiangling",
    roomType: "观景大床",
    realTimePrice: 640,
    historyAvgPrice: 330,
    premiumRate: 93.94,
    complaintCount30Days: 1,
    dealStatus: 'doing',
    complaints: [
      { type: '客房物资', content: '山区昼夜温差大，配套薄被褥 —— 渠道：携程' }
    ],
    warnings: [{
      id: "wy-jiangling-tianyuan-1",
      message: "旺季随意上下架房型，重点盯控库存价格",
    }],
    priceTrend: {
      week7: [640, 640, 640, 580, 520, 420, 350],
      week14: [210, 242, 274, 306, 338, 370, 402, 640, 640, 580, 520, 420, 350, 320]
    }
  },
]

// ==================== 监管预警工单 ====================
export const priceSupervisionWorkOrders = [
  { id: "order_001", hotelName: '篁岭明园山居民宿', roomType: '晒秋观景大床房', premiumPrice: 1160, warningTime: '09:15', premiumRate: 90.16, dealStatus: 'doing' },
  { id: "order_002", hotelName: '篁岭晚溪徽舍民宿', roomType: '徽派山景双床', premiumPrice: 1070, warningTime: '10:22', premiumRate: 84.48, dealStatus: 'doing' },
  { id: "order_003", hotelName: '婺女洲梦里水乡民宿', roomType: '湖景亲水双床', premiumPrice: 870, warningTime: '11:08', premiumRate: 123.08, dealStatus: 'doing' },
  { id: "order_004", hotelName: '婺女洲园居别院民宿', roomType: '园林庭院大床', premiumPrice: 800, warningTime: '14:05', premiumRate: 113.33, dealStatus: 'doing' },
  { id: "order_005", hotelName: '李坑山房徽韵民宿', roomType: '古村蜜月大床房', premiumPrice: 750, warningTime: '16:20', premiumRate: 97.37, dealStatus: 'doing' },
  { id: "order_006", hotelName: '婺源城心简居民宿', roomType: '城市高级大床', premiumPrice: 320, warningTime: '17:30', premiumRate: 77.78, dealStatus: 'doing' },
]


// WEBPACK FOOTER //
// ./src/utils/priceSupervisionData.js